export default "/_next/static/media/tem1.adc9dbe6481c20081ecc16ed68b904cb.jpg";